import React, { useMemo, useState } from 'react';
import CustomSideNav from './sidenav';
import useStore from '../store/zustandstore';
import { useLocation } from 'react-router-dom';
import { isPublicIntakePath } from '../api/allowToken';
import { unrestrictedRoutes } from '../permisiions';

const hasStaffToken = () => {
  try {
    return Boolean(window.localStorage.getItem('auth'));
  } catch (e) {
    return false;
  }
};

const SideNavLayout = ({ children }) => {
  // Every page starts with the slim icon rail (request 2026-10-05); the
  // toggle expands it.
  const [isCollapsed, setIsCollapsed] = useState(true);
  const isSidenav = useStore((state) => state.isSidenav);
  const location = useLocation();
  const contentStyle = {
    marginLeft: isCollapsed ? 68 : 240,
    // The rail's collapse toggle is deliberately hung outside the nav
    // (sidenav.jsx, right: -12), so it lands on top of whatever the page renders
    // first. Clear its width here rather than every page working around it.
    paddingLeft: 40,
    transition: 'margin-left 200ms ease',
    minHeight: '100vh',
  };
  const queryParams = useMemo(() => new URLSearchParams(window.location.search), []);
  const allowToken = queryParams.get('allowtoken'); // special flow token
  const sidebarParam = queryParams.get('sb'); // optional codes or SD
  // Public pages never get the staff rail: the patient-intake links
  // (/onboard-odessa|frisco, /patient, /patient-enrollment; with or without
  // ?allowtoken=, which the Apache short links stop sending) and any other
  // sign-in-free route opened without a staff sign-in. The rail is staff
  // navigation (Home, Logout, ...) and its Form Inbox badge polls a staff-only
  // route: with no token that is a 401, and api.js's refresh + /login redirect
  // would take a patient off the intake form (sec-DEPLOY.md 0.8).
  const isUnrestricted = unrestrictedRoutes.some((route) => location.pathname.startsWith(route));
  if (isPublicIntakePath(location.pathname) || (isUnrestricted && !hasStaffToken())) {
    return children;
  }
   let showSidebar = isSidenav;
    if (allowToken) {
    // special flow: check sidebar param
    if (sidebarParam) {
      showSidebar = true; 
    } else {
      showSidebar =false; 
    }
  } else {
    // normal flow: show sidebar only if isSidenav
    showSidebar = isSidenav;
  }
  if (!showSidebar) {
    return children;
  }
  
 // /tasks used to get its own grey panel; it now sits on the same near-white
 // canvas as every other page.
 const bgColor = 'bg-[#FAFAF9]';
  return (
    <div className="flex">
      <CustomSideNav isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
      <div
             className={`flex-grow p-2 md:p-4 min-h-screen min-w-0 ${bgColor}`}
        style={contentStyle}
      >
        {children}
      </div>
    </div>
  );
};

export default SideNavLayout;
